import api from './api';

export const getBulkLeaves = (params) => api.get('/v1/bulk-leaves', { params });
export const getBulkLeave = (id) => api.get(`/v1/bulk-leaves/${id}`);
export const createBulkLeave = (data) => api.post('/v1/bulk-leaves', data);
export const deleteBulkLeave = (id) => api.delete(`/v1/bulk-leaves/${id}`);
export const addUsers = (id, data) => api.post(`/v1/bulk-leaves/${id}/users`, data);
export const removeUser = (id, userId) => api.delete(`/v1/bulk-leaves/${id}/users/${userId}`);
export const removeAllUsers = (id, ids) => api.delete(`/v1/bulk-leaves/${id}/users`, { data: { ids } });
export const getUsers = (id, params) => api.get(`/v1/bulk-leaves/${id}/users`, { params });
